<template>
  <a-layout style="padding-top: 65px;">
    <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '720px' }">
      <!--  查新&新增按钮 -->
      <p>
        <a-form layout="inline" :model="param">
          <a-form-item>
            <a-button type="primary" @click="handleQuery()">
              查询
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="add()">
              新增
            </a-button>
          </a-form-item>
        </a-form>
      </p>

      <!--  小提示 -->
      <p>
        <a-alert class="tip" message="小提示：这里的分类会显示到首页的侧边菜单" type="info" closable />
      </p>

      <!--  树形表格 -->
      <!--  :row-key="record => record.id" -->
      <a-table v-if="level1.length > 0" :columns="columns" :data-source="level1" :loading="loading" :pagination="false"
        :defaultExpandAllRows="true">
        <template #cover="{ text: cover }">
          <img v-if="cover" :src="cover" alt="avatar" />
        </template>
        <!--  已废弃 v-slot:action="{ record }" -->
        <template v-slot:bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <a-space size="small">
              <a-button type="primary" @click="edit(record)">
                编辑
              </a-button>
              <a-popconfirm title="删除后不可恢复，确认删除?" ok-text="是" cancel-text="否" @confirm="handleDelete(record.id)">
                <a-button type="primary" danger>
                  删除
                </a-button>
              </a-popconfirm>
            </a-space>
          </template>
        </template>

      </a-table>
    </a-layout-content>

    <TheFooter></TheFooter>

  </a-layout>

  <!-- 增加&修改模态弹窗-->
  <a-modal title="分类表单" v-model:open="modalVisible" :confirm-loading="modalLoading" @ok="handleModalOk">
    <a-form :model="category" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="名称">
        <a-input v-model:value="category.name" :allowClear="true" placeholder="请输入名称" />
      </a-form-item>
      <a-form-item label="父分类">
        <a-select v-model:value="category.parent" ref="select" placeholder="请选择父节点">
          <a-select-option :value="0">
            无
          </a-select-option>
          <a-select-option v-for="c in level1" :key="c.id" :value="c.id" :disabled="category.id === c.id">
            {{ c.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="顺序">
        <a-input v-model:value="category.sort" :allowClear="true" type="number" min="1" placeholder="请输入序号" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import TheFooter from "@/components/the-footer.vue";

export default defineComponent({
  name: 'AdminCategory',
  components: {
    TheFooter
  },
  setup() {
    const param = ref();
    param.value = {};
    const categorys = ref();
    const loading = ref(false);

    const columns = [
      {
        title: '名称',
        dataIndex: 'name'
      },
      {
        title: '父分类',
        key: 'parent',
        dataIndex: 'parent'
      },
      {
        title: '顺序',
        dataIndex: 'sort'
      },
      {
        title: 'Action',
        dataIndex: 'action',
      }
    ];

    /**
     * 一级分类树，children属性就是二级分类
     * [{
     *   id: "",
     *   name: "",
     *   children: [{
     *     id: "",
     *     name: "",
     *   }]
     * }]
     */
    const level1 = ref(); // 一级分类树，children属性就是二级分类
    level1.value = [];

    /**
     * 数据查询
     **/
    const handleQuery = () => {
      loading.value = true;
      // 如果不清空现有数据，则编辑保存重新加载数据后，再点编辑，则列表显示的还是编辑前的数据
      level1.value = [];
      axios.get("/category/all").then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          categorys.value = result.data.list;
          console.log("原始数组：", categorys.value);

          /**
           * 表格支持树形数据的展示，当数据中有 children 字段时会自动展示为树形表格，
           * 如果不需要或配置为其他字段可以用 childrenColumnName 进行配置。
           * 可以通过设置 indentSize 以控制每一层的缩进宽度。
           */
          level1.value = [];
          level1.value = Tool.array2Tree(categorys.value, 0);
          console.log("树形结构：", level1);
        } else {
          message.error(result.message);
        }
      });
    };

    // -------- 表单 ---------
    const category = ref();
    const modalVisible = ref(false);
    const modalLoading = ref(false);
    const handleModalOk = () => {
      // 判空
      if (category.value.name == undefined || category.value.name.trim() == ''
        || category.value.parent == undefined
        || category.value.name == parent || category.value.sort == undefined) {
        message.warning('请补全数据')
        return
      }

      modalLoading.value = true;
      axios.post("/category/save", category.value).then((response) => {
        modalLoading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          modalVisible.value = false;
          message.success('提交成功')
          // 重新加载列表
          handleQuery();
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 编辑
     */
    const edit = (record: any) => {
      modalVisible.value = true;
      category.value = Tool.copy(record);
    };

    /**
     * 新增
     */
    const add = () => {
      modalVisible.value = true;
      category.value = {};
    };

    const handleDelete = (id: number) => {
      axios.delete("/category/delete/" + id).then((response) => {
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success('操作成功')
          // 重新加载列表
          handleQuery();
        } else {
          message.error(result.message);
        }
      });
    };

    onMounted(() => {
      handleQuery();
    });

    return {
      param,
      categorys,
      level1,
      columns,
      loading,
      handleQuery,

      edit,
      add,

      category,
      modalVisible,
      modalLoading,
      handleModalOk,

      handleDelete
    }
  }
});
</script>

<style scoped>
img {
  width: 50px;
  height: 50px;
}
</style>
